// extracted by mini-css-extract-plugin
module.exports = {"sk-folding-cube":"Spinner_sk-folding-cube__1c9Rn","loader":"Spinner_loader__2ei93","spin":"Spinner_spin__3l21M"};